import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  headerContainer: (theme, { embed }) => css`
    background-color: ${theme.colors.background.white};
    margin-bottom: ${embed ? theme.spacing.xxs : 0};
    z-index: 2;
  `,

  navLogo: (_, { conexaLogo }) => css`
    max-width: ${conexaLogo ? '135px' : '150px'};
    max-height: 40px;
    cursor: pointer;
  `,

  navItemWithNotification: theme => css`
    &:before {
      content: '';
      left: -${theme.spacing.xs};
      width: ${theme.spacing.xxs};
      height: ${theme.spacing.xxs};
      border-radius: ${theme.border.radius.full};
      margin-right: ${theme.spacing.xxs};
      background-color: ${theme.colors.brand.secondary[300]};
    }
  `,
})

export default useStyles
